var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.0001V28.0001M28 32.0001H28.01M19 23.9415V32.0586C19 32.4013 19 32.5726 19.0505 32.7254C19.0951 32.8606 19.1682 32.9847 19.2646 33.0893C19.3737 33.2077 19.5234 33.2909 19.823 33.4573L27.223 37.5684C27.5066 37.726 27.6484 37.8047 27.7985 37.8356C27.9315 37.863 28.0685 37.863 28.2015 37.8356C28.3516 37.8047 28.4934 37.726 28.777 37.5684L36.177 33.4573C36.4766 33.2909 36.6263 33.2077 36.7354 33.0893C36.8318 32.9847 36.9049 32.8606 36.9495 32.7254C37 32.5726 37 32.4013 37 32.0586V23.9415C37 23.5989 37 23.4276 36.9495 23.2748C36.9049 23.1396 36.8318 23.0155 36.7354 22.9108C36.6263 22.7925 36.4766 22.7093 36.177 22.5429L28.777 18.4318C28.4934 18.2742 28.3516 18.1954 28.2015 18.1645C28.0685 18.1372 27.9315 18.1372 27.7985 18.1645C27.6484 18.1954 27.5066 18.2742 27.223 18.4318L19.823 22.5429C19.5234 22.7093 19.3737 22.7925 19.2646 22.9108C19.1682 23.0155 19.0951 23.1396 19.0505 23.2748C19 23.4276 19 23.5989 19 23.9415Z",
    stroke: "#B42318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.399e4578dfa75182688dda4dc8315be3.svg";
export { ForwardRef as ReactComponent };